import styled, { css } from 'styled-components';

interface ContainerProps {
  houseSize?: number,
  blur?: boolean,
  isSubFocused?: boolean,
  isFocused?: boolean,
  isTransparent?: boolean,
  isDeadHouse?: boolean,
  isHighlight?: boolean,
  isCorrect?: 'sim' |'nao' | '',
  isRevealed?: boolean,
}

interface DicaInternaTextoProps {
  zoom: number,
}

export const Container = styled.div<ContainerProps>`
  border: solid 1px #736877;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;

  ${(props) => {
    if (props.blur) {
      return css`
      background-color: rgb(72, 233, 152);
     `;
    } else {
      return css`
      background: ${({ theme }) => theme.background};
      `;
    }
  }
  }
 
  ${(props) => {
    if (props.houseSize) {
      return (
        css`
          width: ${`${props.houseSize}px`};
          height: ${`${props.houseSize}px`};

          @media (min-width: 550px) and (max-width: 800px) {
            width: calc(${props.houseSize} * 0.001 * 130VW);
            height: calc(${props.houseSize} * 0.001 * 130vw);
          }
          
          @media (min-width: 550px) and (max-width: 900px) {
            width: calc(${props.houseSize} * 0.001 * 120VW);
            height: calc(${props.houseSize} * 0.001 * 120vw);
          }

          @media (max-width: 900px) and (min-width: 550px) and (min-height: 955px) {
            width: calc(${props.houseSize} * 0.001 * 120VW);
            height: calc(${props.houseSize} * 0.001 * 120vw);
          }

          @media (max-width: 900px) and (min-width: 550px) and (min-height: 1130px) {
            width: calc(${props.houseSize} * 0.001 * 100VW);
            height: calc(${props.houseSize} * 0.001 * 100vw);
          }

          @media (min-width: 900px) and (min-height: 1056px) {
            width: calc(${props.houseSize} * 0.001 * 100VW);
            height: calc(${props.houseSize} * 0.001 * 100vw);
          }

          @media (min-width: 900px) and (min-height: 1138px) {
            width: calc(${props.houseSize} * 0.001 * 70vw);
            height: calc(${props.houseSize} * 0.001 * 70vw);
          }
          
          @media (max-width: 550px) {
            width: calc(${props.houseSize} * 0.001 * 155VW);
            height: calc(${props.houseSize} * 0.001 * 155VW);
          }

          @media (max-width: 550px) and (min-height: 870px) {
            width: calc(${props.houseSize} * 0.001 * 130vw);
            height: calc(${props.houseSize} * 0.001 * 130vw);
          }

          @media (max-width: 550px) and (min-height: 1030px) {
            width: calc(${props.houseSize} * 0.001 * 120vw);
            height: calc(${props.houseSize} * 0.001 * 120vw);
          }

          @media (max-width: 550px) and (max-height: 780px) and (min-width: 500px) {
            width: calc(${props.houseSize} * 0.001 * 130vw);
            height: calc(${props.houseSize} * 0.001 * 130vw);
          }

          @media (max-width: 550px) and (max-height: 480px) and (min-width: 500px) {
            width: calc(${props.houseSize} * 0.001 * 120vw);
            height: calc(${props.houseSize} * 0.001 * 120vw);
          }

          @media (max-width: 500px) and (max-height: 780px) and (min-width: 450px) {
            width: calc(${props.houseSize} * 0.001 * 130vw);
            height: calc(${props.houseSize} * 0.001 * 130vw);
          }

          @media (max-width: 500px) and (max-height: 500px) and (min-width: 450px) {
            width: calc(${props.houseSize} * 0.001 * 120vw);
            height: calc(${props.houseSize} * 0.001 * 120vw);
          }
         `
      );
    }
  }
  }

  ${(props) => props.isFocused && css`
    border: solid 1px ${({ theme }) => theme.smoothBlue};
  `}
  ${(props) => props.isSubFocused && css`
    background-color: ${({ theme }) => theme.smoothBlue} ;
  `}
  ${(props) => props.isTransparent && css`
  background-color: transparent ;
  border: solid 1px rgba(35, 11, 51, 0.4);

  `}
  ${(props) => props.isDeadHouse && css`
    z-index: 10;

  `}

  ${(props) => {
    if (props.isCorrect === 'sim') {
      return css`
      background-color: ${({ theme }) => theme.green};
      color: ${({ theme }) => theme.white} !important;
     `;
    }
    if (props.isCorrect === 'nao') {
      return css`
      background-color: ${({ theme }) => theme.red};
      color: ${({ theme }) => theme.white} !important;
     `;
    }
  }
}

  ${(props) => props.isRevealed && css`
    background-color: ${({ theme }) => theme.revealed};
  `}
`;


export const Touch = styled.div<ContainerProps>`
  height: 96%;
  width: 96%;
  ${(props) => props.isHighlight && css`
    border: solid 2.5px ${({ theme }) => theme.nimbus};
  `}
  ${(props) => props.isFocused && css`
  height: 100%;
  width: 100%;
    border: solid 1px ${({ theme }) => theme.nimbus};
  `}
`;


export const InputValue = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: ${({ theme }) => theme.text};
  text-align: center;
  font-size: 1.2rem;

`;

//###########################
//     design of direct
//###########################

export const DicaInternaContainer = styled.div`
 width: 100%;
 align-items:center;
 justify-content:center;
 overflow:hidden;
 :hover {
    transform: scale(2); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
    transition: transform .5s;
    background-image: linear-gradient(to top right, rgba(134,79,151,1), rgba(255,180,72,1));
    padding: 3px;
    color: white;
    z-index:99999;
  }
`;

export const Divisor = styled.div`
 width: 80%;
 height: 0.4px;
 background-color: #fff;

 align-items:center;
 justify-content:center;
`;

export const DicaInternaTexto = styled.p<DicaInternaTextoProps>`
  color: #fff;
  text-align: center;
  letter-spacing: -0.5px;
  ${(props) => props.zoom && css`
    font-size: ${`${(5 * props.zoom)}px`};

  `}

`;

export const ArrowContainer = styled.div`
  z-index: 10;
  position:absolute;
  left:50%;

`;

export const Arrow = styled.img`
  z-index: 10;
  position:absolute;
  left: 100%;
  width: 25%;
  height: auto;
`;

export const ArrowBottom = styled.img`
  z-index: 999;
  position:absolute;
  top: 104%;
  width: 25%;
  height: auto;
  transform: rotate(90deg);
`;

export const ArrowCurvedBottom = styled.img`
  z-index: 999;
  position:absolute;
  top: 100%;
  left: 0;
  width: 40%;
  height: auto;
`;

export const ArrowCurvedUp = styled.img`
  z-index: 10;
  position:absolute;
  bottom: 100%;

  left: 2px;
  transform: rotate(270deg);  
  width: 40%;
  height: auto;
`;

export const ArrowCurvedRight = styled.img`
  z-index: 10;
  position:absolute;
  left: 100%;
  bottom: 40%;
  width: 40%;
  height: auto;

`;

export const ArrowCurvedLeft = styled.img`
  z-index: 10;
  position:absolute;
  bottom: 40%;
  right: 100%;
  width: 40%;
  height: auto;
`;
